const pfS=(()=>{let map=null;return (text,vars)=>{if(!map){map={};const box=document.createElement('textarea');document.querySelectorAll('script[data-pf-strings]').forEach(el=>{try{const o=JSON.parse(el.textContent);for(const k in o){box.innerHTML=o[k];const v=box.value;if(v&&!/^translation missing/i.test(v))map[k]=v;}}catch(e){}});}let out=map[text]??text;if(vars)for(const k in vars)out=out.split('{'+k+'}').join(String(vars[k]));return out;};})();
function improveSizeGuide(root, dialog) {
  if (!dialog || dialog.dataset.sizeUsable) return;
  dialog.dataset.sizeUsable = 'true'; dialog.classList.add('pf-size-usable');
  const advice = dialog.querySelector('[data-size-advice]');
  if (advice && dialog.querySelector('.pf-size-kicker')) dialog.querySelector('.pf-size-kicker').textContent = pfS('GRÖSSE & PASSFORM');
  const tables = [...dialog.querySelectorAll('table')];
  const measured = advice ? [] : tables.filter(table => !table.closest('.pf-fit-advice'));
  const intro = dialog.querySelector('.pf-size-intro') || document.createElement('p');
  intro.className = 'pf-size-intro';
  intro.textContent = measured.length ? pfS('Alle Kleidungsmaße in cm. Vergleichen Sie mit einem gut passenden Kleidungsstück.') + (measured.some(table => /Körpergröße|Gewicht/.test(table.textContent)) ? ' ' + pfS('Körpergröße und Gewicht (kg) sind nur Orientierungshilfen.') : '') : pfS('Orientieren Sie sich an Ihrer üblichen Größe. Zwischen zwei Größen oder mit einem dicken Pullover darunter wählen Sie die größere Größe. Diese Beratung enthält keine modellspezifischen Maße.');
  if (!intro.parentElement) dialog.querySelector('.jnh-dialog-head')?.after(intro);
  const matrix = measured.some(table => /Gewicht.*Körpergröße/.test(table.rows[0]?.cells[0]?.textContent || ''));
  if (matrix) intro.textContent = pfS('Körpergröße in cm, Körpergewicht in kg. Die Tabelle gibt eine Größenempfehlung; sie enthält keine Kleidungsmaße. Leere Felder bedeuten: keine Empfehlung verfügbar.');
  tables.forEach(table => {
    const isMeasured = measured.includes(table);
    const wrapper = document.createElement('div'); wrapper.className = 'pf-guide-scroll';
    table.before(wrapper); wrapper.append(table);
    if (isMeasured) {
      table.dataset.measurementTable = 'true';
      table.querySelectorAll('tr:first-child th').forEach(cell => {
        const original = cell.textContent.trim(); cell.title = original;
        const clean = original.replace(/\s*\([^)]*\)/g, '').trim();
        const names = {'Empfohlene Körpergröße':'Körpergröße', 'Empfohlenes Körpergewicht':'Gewicht', 'Rückenlänge':'Länge', 'Brustumfang':'Brust', 'Taillenumfang':'Taille', 'Schulterbreite':'Schulter', 'Ärmellänge':'Ärmel', 'Hüftumfang':'Hüfte'};
        const soft = {'Körpergröße':'Körper\u00ADgröße', 'Handgelenk':'Hand\u00ADgelenk', 'Schultern':'Schul\u00ADtern', 'Schulter':'Schul\u00ADter'};
        const isMatrix = /Gewicht.*Körpergröße/.test(original); const label = isMatrix ? 'Gewicht / Größe' : names[clean] || clean;
        cell.textContent = soft[label] || label;
        const unit = !isMatrix && (original.match(/\((cm|kg)\)/i) || [])[1];
        if (unit) { const u = document.createElement('small'); u.className = 'pf-unit'; u.textContent = unit; cell.append(u); }
        cell.setAttribute('scope', 'col');
      });
      table.querySelectorAll('tbody tr').forEach(row => row.cells[0]?.setAttribute('scope', 'row'));
    } else table.dataset.adviceTable = 'true';
  });
  const content = dialog.querySelector('[data-size-content]');
  if (content) {
    const chart = content.querySelector('.pf-fjord-table');
    if (chart) content.prepend(chart);
  }
  if (measured.length) {
    const norm = value => String(value).toUpperCase().replace(/\s/g,'').replace(/^XXL$/,'2XL').replace(/^XXXL$/,'3XL');
    const covered = new Set(measured.flatMap(table => [...table.rows].slice(1).flatMap(row => [...row.cells].flatMap(cell => cell.textContent.split('/')))).map(norm));
    const variants = root.v || root.variants || [];
    const sizes = [...new Set(variants.flatMap(variant => (variant.options || []).filter(value => /^(XXS|XS|S|M|L|XL|XXL|XXXL|[2-9]XL)$/i.test(value))))];
    const missing = sizes.filter(size => !covered.has(norm(size)));
    if (missing.length) {
      const note = document.createElement('p'); note.className = 'pf-guide-missing';
      note.textContent = pfS('Für {sizes} sind noch keine bestätigten Modellmaße verfügbar. Bitte lassen Sie sich vor der Bestellung vom Kundenservice zur Größe beraten.', { sizes: missing.join(', ') });
      const last = measured[measured.length-1].closest('.pf-guide-scroll'); last?.after(note);
    }
  }
}

import { addPackGifts, showCartAddProgress } from './pf-real-pack-gifts.js?v=20261030-nobag';
import { CartAddEvent } from '@theme/events';
// Money in the shop's own format (same output as the Liquid money filter, e.g. "1 292,31 zł"), derived from a sample rendered by the section.
const pfMoneyFormat=(el,locale)=>{const m=String(el.dataset.moneySample||'').trim().match(/^([\s\S]*?)1(\D?)234\2(?:567)(?:(\D)00)?(?!\d)([\s\S]*)$/);if(!m)return new Intl.NumberFormat(locale||'de-DE',{style:'currency',currency:el.dataset.currency});const[,pre,group,dec,suf]=m;const digits=dec?2:0;return{format:n=>{let[a,b]=Math.abs(n).toFixed(digits).split('.');a=a.replace(/\B(?=(\d{3})+(?!\d))/g,group);return(n<0?'-':'')+pre+a+(digits?dec+b:'')+suf;}};};
class JacketNineheatMain extends HTMLElement {
  connectedCallback() {
    this.abort = new AbortController();
    this.variants = JSON.parse(this.querySelector('[data-variants]').textContent);
    this.copy = JSON.parse(this.querySelector('[data-copy]').textContent);
    this.format = pfMoneyFormat(this, JSON.parse(this.querySelector('[data-money]').textContent).locale);
    this.form = this.querySelector('[data-form]');
    this.count = 1;
    const initial = this.variants.find(v => String(v.id) === this.querySelector('[data-variant-id]').value) || this.variants[0];
    this.setOptions(initial);
    this.packSelections = [];
    this.makeExtraPicks();
    this.classList.add('jnh-compact-ready');
    this.addEventListener('change', e => {
      if (e.target.matches('.jnh-pack-card > input[type=radio]')) {
        this.count = Number(e.target.value);
        this.makeExtraPicks();
      }
      if (e.target.closest('.jnh-extra-primary')) {
        const row = e.target.closest('.jnh-extra-primary');
        const chosen = this.variantFromRow(row);
        if (chosen) this.setOptions(chosen);
      }
      this.update();
    }, { signal: this.abort.signal });
    this.form.addEventListener('submit', e => this.add(e), { signal: this.abort.signal });
    this.querySelector('[data-prev]').addEventListener('click', () => this.move(-1), { signal: this.abort.signal });
    this.querySelector('[data-next]').addEventListener('click', () => this.move(1), { signal: this.abort.signal });
    this.querySelector('[data-track]').addEventListener('scroll', () => { this.highlightThumb(); this.loadSlide(this.index); this.loadSlide(this.index + 1); }, { passive: true, signal: this.abort.signal });
    this.querySelectorAll('[data-size-open]').forEach(b => b.addEventListener('click', () => {
      const dialog = this.querySelector('[data-size-dialog]');
      dialog.querySelector('details')?.setAttribute('open', '');
      improveSizeGuide(this, dialog);
      dialog.showModal();
    }, { signal: this.abort.signal }));
    this.querySelector('[data-size-close]').addEventListener('click', () => this.querySelector('[data-size-dialog]').close(), { signal: this.abort.signal });
    this.querySelectorAll('.jnh-sticky a, [data-choices-link]').forEach(link => link.addEventListener('click', e => { e.preventDefault(); const choices = this.querySelector('[data-extra-picks]'); choices.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block: 'start' }); }, { signal: this.abort.signal }));
    this.update(false);
    const sticky = this.querySelector('[data-sticky]');
    let mainButtonVisible = false;
    const updateSticky = () => {
      const hidden = window.scrollY < 80 || mainButtonVisible;
      sticky.classList.toggle('is-hidden', hidden);
      sticky.setAttribute('aria-hidden', String(hidden));
      sticky.inert = hidden;
    };
    updateSticky();
    window.addEventListener('scroll', updateSticky, { passive: true, signal: this.abort.signal });
    this.stickyObserver = new IntersectionObserver(entries => {
      mainButtonVisible = entries[0].isIntersecting;
      updateSticky();
    });
    this.stickyObserver.observe(this.querySelector('[data-atc]'));
  }
  disconnectedCallback() { this.closeDropdown?.(); this.abort?.abort(); this.stickyObserver?.disconnect(); }
  t(source, replacements = {}) {
    let value = this.copy[source] || pfS(source);
    for (const [key, text] of Object.entries(replacements)) value = value.replaceAll(`__${key}__`, String(text));
    return value;
  }
  colorOf(v) { return /Blau|Blu|Niebiesk|Blue|ブルー/i.test(v.option1) ? 'Blau' : 'Schwarz'; }
  setOptions(v) {
    this.querySelector(`[data-version-options] input[value="${v.option1.includes('21') ? '21' : '9'}"]`).checked = true;
    this.querySelector(`[data-color-options] input[value="${this.colorOf(v)}"]`).checked = true;
    [...this.querySelectorAll('[data-size-options] input')].find(i => i.value === v.option2).checked = true;
  }
  selected() {
    const version = this.querySelector('[data-version-options] input:checked').value;
    const color = this.querySelector('[data-color-options] input:checked').value;
    const size = this.querySelector('[data-size-options] input:checked').value;
    return this.variants.find(v => (v.option1.includes('21') ? '21' : '9') === version && this.colorOf(v) === color && v.option2 === size);
  }
  variantFromRow(row) {
    const version = row.querySelector('[data-extra-version]').value;
    const color = row.querySelector('[data-extra-color]').value;
    const size = row.querySelector('[data-extra-size]').value;
    return this.variants.find(v => (v.option1.includes('21') ? '21' : '9') === version && this.colorOf(v) === color && v.option2 === size);
  }
  picked() {
    return [...this.querySelectorAll('.jnh-extra')].map(row => this.variantFromRow(row));
  }
  makeExtraPicks() {
    this.closeDropdown?.();
    const host = this.querySelector('[data-extra-picks]');
    const previous = [...host.querySelectorAll('.jnh-extra')].map(row => this.variantFromRow(row));
    previous.forEach((v, i) => { if (v) this.packSelections[i] = v; });
    host.replaceChildren(); host.hidden = false;
    const active = this.querySelector('.jnh-pack-card > input:checked').parentElement.querySelector('.jnh-pack-content');
    active.insertBefore(host, active.querySelector('.jnh-gift-grid'));
    for (let i = 0; i < this.count; i++) {
      const row = document.createElement('div'); row.className = 'jnh-extra' + (i === 0 ? ' jnh-extra-primary' : '');
      const title = document.createElement('h3'); title.textContent = this.t('Jacke __COUNT__ · Ihre Auswahl', { COUNT: i + 1 });
      const grid = document.createElement('div'); grid.className = 'jnh-extra-grid';
      const v = i === 0 ? this.selected() : this.packSelections[i] || this.selected();
      for (const [name, key, values, value] of [
        [this.t('Ausführung'), 'extraVersion', ['9', '21'], v.option1.includes('21') ? '21' : '9'],
        [this.t('Farbe'), 'extraColor', ['Schwarz', 'Blau'], this.colorOf(v)],
        [this.t('Größe'), 'extraSize', [...new Set(this.variants.map(x => x.option2))], v.option2]
      ]) {
        const label = document.createElement('div'); label.className = 'jnh-dropdown-field';
        const caption = document.createElement('span'); caption.className = 'jnh-dropdown-caption'; caption.textContent = name; label.append(caption);
        const select = document.createElement('select'); select.dataset[key] = ''; select.setAttribute('aria-label', this.t('Jacke __COUNT__ · __LABEL__', { COUNT: i + 1, LABEL: name }));
        values.forEach(text => { const option = document.createElement('option'); option.value = text; option.textContent = key === 'extraVersion' ? this.t('__COUNT__ Heizbereiche', { COUNT: text }) : key === 'extraColor' ? this.t(text) : text; select.append(option); });
        select.value = value; select.classList.add('jnh-native-choice');
        const trigger = document.createElement('button'); trigger.type = 'button'; trigger.className = 'jnh-dropdown-trigger';
        trigger.setAttribute('aria-expanded', 'false'); trigger.setAttribute('aria-label', select.getAttribute('aria-label'));
        const current = document.createElement('span'); current.textContent = select.selectedOptions[0].textContent;
        const arrow = document.createElement('span'); arrow.textContent = '⌄'; arrow.setAttribute('aria-hidden', 'true');
        trigger.append(current, arrow);
        trigger.addEventListener('click', e => { e.preventDefault(); this.openChoice(select, trigger, current); }, { signal: this.abort.signal });
        label.append(select, trigger);
        if (key === 'extraSize') {
          const guide = document.createElement('button'); guide.type = 'button'; guide.className = 'jnh-pack-guide jnh-size-adjacent';
          guide.textContent = document.documentElement.lang.startsWith('de') ? this.t('Größentabelle') : this.t('Maße ansehen');
          guide.addEventListener('click', () => this.querySelector('[data-size-open]').click(), { signal: this.abort.signal });
          title.append(guide);
        }
        grid.append(label);
      }
      row.append(title, grid);
      host.append(row);
    }
  }
  openChoice(select, trigger, current) {
    const alreadyOpen = trigger.getAttribute('aria-expanded') === 'true';
    this.closeDropdown?.();
    if (alreadyOpen) return;
    const menu = document.createElement('div'); menu.className = 'jnh-dropdown-menu';
    menu.setAttribute('role', 'group'); menu.setAttribute('aria-label', select.getAttribute('aria-label'));
    const lifecycle = new AbortController();
    const close = () => {
      menu.remove(); trigger.setAttribute('aria-expanded', 'false'); lifecycle.abort();
      this.closeDropdown = null;
    };
    this.closeDropdown = close;
    for (const option of select.options) {
      const button = document.createElement('button'); button.type = 'button';
      button.textContent = option.textContent; button.disabled = option.disabled;
      button.setAttribute('aria-pressed', String(option.selected));
      button.addEventListener('click', () => {
        select.value = option.value; current.textContent = option.textContent;
        select.dispatchEvent(new Event('change', { bubbles: true }));
        close(); trigger.focus({ preventScroll: true });
      });
      menu.append(button);
    }
    trigger.parentElement.append(menu); trigger.setAttribute('aria-expanded', 'true');
    document.addEventListener('click', event => {
      if (!trigger.parentElement.contains(event.target)) close();
    }, { signal: lifecycle.signal });
    document.addEventListener('keydown', event => {
      if (event.key === 'Escape') { close(); trigger.focus({ preventScroll: true }); }
    }, { signal: lifecycle.signal });
  }
  update(history = true) {
    const v = this.selected(); this.variant = v;
    const error = this.querySelector('[data-error]'); error.hidden = true;
    this.querySelector('[data-variant-id]').value = v?.id || '';
    // Same rounding as Shopify's automatic pack discounts (−10 % from 2, −17 % from 3): per unit.
    const rateOf = n => n >= 3 ? .17 : n === 2 ? .1 : 0;
    const packPrice = (items, n) => items.reduce((sum, item) => { const p = item?.price || 0; return sum + p - Math.round(p * rateOf(n)); }, 0);
    const price = packPrice(this.picked(), this.count);
    const compare = this.picked().reduce((sum, item) => sum + (item?.compare_at_price || item?.price || 0), 0);
    this.querySelector('[data-price]').textContent = this.format.format(price / 100);
    this.querySelector('[data-compare]').textContent = this.format.format(compare / 100);
    this.querySelector('[data-compare]').hidden = compare <= price;
    this.querySelector('[data-saving]').textContent = compare > price ? this.t('Sie sparen __PRICE__', { PRICE: this.format.format((compare - price) / 100) }) : '';
    this.querySelector('[data-saving]').hidden = compare <= price;
    this.querySelector('[data-pack-intro]').textContent = this.t('__COUNT__ Geschenke in Ihrem Paket inklusive', { COUNT: this.count === 3 ? 13 : this.count === 2 ? 8 : 3 });
    this.querySelectorAll('[data-pack-price]').forEach(el => {
      const count = Number(el.dataset.packPrice);
      const amount = packPrice(count === this.count ? this.picked() : Array(count).fill(v), count);
      const ref = count === this.count ? compare : (v.compare_at_price || v.price) * count;
      el.querySelector('b').textContent = this.format.format(amount / 100);
      el.querySelector('s').textContent = ref > amount ? this.format.format(ref / 100) : '';
    });
    const atc = this.querySelector('[data-atc]'); atc.disabled = this.picked().some(item => !item?.available);
    atc.replaceChildren(document.createTextNode(atc.disabled ? this.t("Derzeit nicht verfügbar") : this.t("In den Warenkorb")));
    if (!atc.disabled) { const span = document.createElement('span'); span.dataset.buttonPrice = ''; span.textContent = this.format.format(price / 100); atc.append(span); }
    this.syncNative();
    if (history && v) { const url = new URL(location.href); url.searchParams.set('variant', v.id); window.history.replaceState({}, '', url); }
    this.querySelector('[data-sticky-price]').textContent = this.format.format(price / 100);
    this.querySelector('[data-sticky-compare]').textContent = compare > price ? this.format.format(compare / 100) : '';
    const stickyBadge = this.querySelector('[data-sticky-badge]');
    stickyBadge.hidden = !(compare > price);
    stickyBadge.textContent = `−${Math.round((compare - price) / compare * 100)}\u00a0%`;
    const offer = this.querySelector('.jnh-gift');
    const meter = offer?.querySelector('[role="meter"]');
    if (meter && v) {
      const total = Number(offer.dataset.offerTotal);
      const remaining = Math.max(0, Math.min(total, Number(v.option1.includes('21') ? offer.dataset.stockTwentyOne : offer.dataset.stockNine)));
      offer.querySelector('.jnh-offer-count b').textContent = remaining;
      offer.querySelector('.jnh-offer-stock').textContent = this.t('Noch __COUNT__ Pakete zu diesem Preis verfügbar', { COUNT: remaining });
      meter.setAttribute('aria-valuenow', total - remaining);
      meter.firstElementChild.style.width = `${(total - remaining) / total * 100}%`;
    }
    this.filterGallery(v);
    const hero = this.slides?.[0]?.querySelector('img');
    if (hero) this.querySelector('[data-sticky-image]').src = hero.currentSrc || hero.src;
    this.dispatchEvent(new CustomEvent('jacket:variant-change', { bubbles: true, detail: { variant: v, version: v.option1.includes('21') ? '21' : '9', color: this.colorOf(v) } }));
  }
  filterGallery(v) {
    const version = v.option1.includes('21') ? '21' : '9'; const color = this.colorOf(v);
    const galleryKey = `${version}:${color}`;
    if (this.galleryKey === galleryKey) return;
    this.galleryKey = galleryKey;
    const slides = [...this.querySelectorAll('.jnh-slide')].filter(s => s.querySelector('img'));
    if (!slides.length) return;
    slides.forEach(slide => { slide.hidden = (!!slide.dataset.version && slide.dataset.version !== 'all' && slide.dataset.version !== version) || (!!slide.dataset.color && slide.dataset.color !== 'all' && slide.dataset.color !== color); });
    this.slides = slides.filter(s => !s.hidden);
    const firstImage = this.slides[0]?.querySelector('img');
    if (firstImage) { firstImage.loading = 'eager'; firstImage.fetchPriority = 'high'; }

    if (!this.slides.length) { slides.forEach(s => s.hidden = false); this.slides = slides; }
    const thumbs = this.querySelector('[data-thumbs]'); thumbs.replaceChildren();
    this.slides.forEach((slide, i) => { const button = document.createElement('button'); button.type = 'button'; button.className = 'jnh-thumb'; button.setAttribute('aria-label', this.t('Bild __COUNT__ ansehen', { COUNT: i + 1 })); const image = (o=>{const n=document.createElement('img');for(const a of o.getAttributeNames())if(a!=='src'&&a!=='srcset'&&a!=='sizes')n.setAttribute(a,o.getAttribute(a));return n})(slide.querySelector('img')); image.loading = 'eager'; const thumbnailSrc = image.getAttribute('data-jnh-src') || image.getAttribute('src'); if (thumbnailSrc) image.setAttribute('src', thumbnailSrc); image.removeAttribute('data-jnh-src'); image.removeAttribute('data-jnh-srcset'); image.removeAttribute('srcset');image.removeAttribute('sizes');image.removeAttribute('fetchpriority');const smallSource=slide.querySelector('img').dataset.thumbnailSrc;if(smallSource){image.src=smallSource;}else{const u=new URL(slide.querySelector('img').getAttribute('data-jnh-src') || slide.querySelector('img').src,location.href);if(u.pathname.includes('/cdn/shop/files/')||u.pathname.includes('/cdn/shop/products/')){u.searchParams.set('width','160');image.src=u.href;}}image.loading='lazy';image.width=160;image.height=160; button.append(image); button.addEventListener('click', () => this.scrollToSlide(i)); thumbs.append(button); });
    const match = v.featured_image?.id && this.slides.findIndex(s => s.dataset.mediaId === String(v.featured_image.id));
    this.scrollToSlide(match >= 0 ? match : 0, false);
  }
  loadSlide(index) {
    const image = this.slides[index]?.querySelector('img');
    if (!image) return;
    image.loading = 'eager';
    if (image.dataset.jnhSrcset) { image.setAttribute('srcset', image.dataset.jnhSrcset); delete image.dataset.jnhSrcset; }
    if (image.dataset.jnhSrc) { image.src = image.dataset.jnhSrc; delete image.dataset.jnhSrc; }
  }
  scrollToSlide(i, smooth = true) { this.loadSlide(i); if (smooth) this.loadSlide(i + 1); const track = this.querySelector('[data-track]'); track.scrollTo({ left: this.slides[i].offsetLeft - track.offsetLeft, behavior: smooth ? 'smooth' : 'instant' }); this.index = i; this.highlightThumb(); }
  move(delta) { this.scrollToSlide((this.index + delta + this.slides.length) % this.slides.length); }
  highlightThumb() { const track = this.querySelector('[data-track]'); this.index = Math.round(track.scrollLeft / Math.max(track.clientWidth, 1)); [...this.querySelectorAll('.jnh-thumb')].forEach((b, i) => b.setAttribute('aria-current', i === this.index ? 'true' : 'false')); }
  // Keep the fields the native Shopify payment button serializes in sync with the chosen pack.
  // Native wallets buy one line (id × quantity). The pack price comes from the automatic discounts
  // ("PyreFit 2 Jacken -10%", "PyreFit 3 Jacken -17%"), so any pack of identical jackets uses the native button.
  // Mixed versions, colours or sizes use the "Jetzt kaufen" fallback.
  syncNative() {
    const atc = this.querySelector('[data-atc]'), form = atc?.form; if (!form) return;
    const picked = this.picked(), n = picked.length || 1, first = picked[0];
    const available = picked.length > 0 && picked.every(v => v?.available);
    const same = picked.every(v => v && first && String(v.id) === String(first.id));
    const native = available && same;
    const set = (sel, value) => { const el = form.querySelector(sel); if (el) el.value = value; };
    if (first) set('[data-variant-id]', String(first.id));
    set('[data-native-qty]', String(native ? n : 1));
    set('[data-native-pack]', this.t(n === 3 ? 'Familien-Set' : n === 2 ? 'Duo-Set' : 'Komplett-Set'));
    set('[data-native-gift]', n === 1 ? pfS('20.000-mAh-Akku gratis + Ladekabel & Wäschenetz') : pfS('{n}× 20.000-mAh-Akku gratis + {n} Mützen & {n} Wäschenetze', { n }) + (n === 3 ? ' ' + pfS('+ 1 Handwärmer') : ''));
    const dyn = form.querySelector('[data-dyn]'), wrap = form.querySelector('[data-buy-now-wrap]');
    if (dyn) dyn.hidden = !native; if (wrap) wrap.hidden = native || !available;
    if (atc.offsetHeight) form.style.setProperty('--pf-dyn-h', atc.offsetHeight + 'px');
  }
  async add(e) {
    e.preventDefault();
    if (this.adding) return;
    // "Jetzt kaufen" (data-buy-now) adds exactly the same pack and gift lines, then goes to the checkout.
    const buyNow = e.submitter?.hasAttribute?.('data-buy-now') ? e.submitter : null;
    if (buyNow && this.querySelector('[data-atc]').disabled) return;
    this.adding = true;
    let redirecting = false;
    const buyNowLabel = buyNow?.textContent;
    if (buyNow) { buyNow.disabled = true; buyNow.setAttribute('aria-busy', 'true'); buyNow.textContent = this.t('Weiter zur Kasse …'); }
    const packCount = this.count;
    const picked = this.picked().map(variant => ({ ...variant })); const button = this.querySelector('[data-atc]'); button.disabled = true;
    const error = this.querySelector('[data-error]'); error.hidden = true;
    let added = false;
    let finishProgress = () => {};
    try {
      // The pack price comes from the automatic discounts; no discount code is applied any more.
      const isPack = packCount > 1;
      const sectionIds = [...new Set([...document.querySelectorAll('cart-items-component')].map(el => el.dataset.sectionId).filter(Boolean))];
      const root = window.Shopify?.routes?.root || '/';
      const packId = crypto.randomUUID();
      const gifted = packCount === 3 ? this.t("3 Powerbanks, 3 Mützen, 1 Handwärmer und 3 Wäschenetze") : packCount === 2 ? this.t("2 Powerbanks, 2 Mützen und 2 Wäschenetze") : this.t("1 Powerbank und 1 Wäschenetz");
      const items = picked.map((v, index) => ({ id: v.id, quantity: 1, properties: { _Komplettpaket: this.t("20.000-mAh-Powerbank und Ladekabel inklusive"), _Paket: packCount === 3 ? this.t("Familien-Set") : packCount === 2 ? this.t("Duo-Set") : this.t("Komplett-Set"), _Geschenke: index === 0 ? gifted : this.t("Im Paket enthalten"), _PyreFitRealGifts: "1", _PyreFitPack: packId, _PyreFitGarment: `${packId}-${index}` } }));
      finishProgress = showCartAddProgress();
      const drawer = buyNow ? null : document.querySelector('cart-drawer-component');
      if (drawer && !document.getElementById('pf-cart-loading-style')) {
        const st = document.createElement('style'); st.id = 'pf-cart-loading-style';
        st.textContent = '.pf-cart-loading cart-items-component{opacity:.35;pointer-events:none;transition:opacity .15s}.pf-cart-loading dialog{position:relative}.pf-cart-loading dialog::after{content:'+JSON.stringify(pfS('Wird hinzugefügt …'))+';position:absolute;left:50%;top:38%;transform:translateX(-50%);padding:10px 18px;border-radius:999px;background:#16181d;color:#fff;font:600 14px/1.2 system-ui,sans-serif;z-index:5}';
        document.head.append(st);
      }
      drawer?.classList.add('pf-cart-loading'); drawer?.open();
      const prevFinish = finishProgress; finishProgress = () => { drawer?.classList.remove('pf-cart-loading'); prevFinish(); };
      const single = packCount === 1 && items.length === 1;
      const giftIds = { battery: 66154581328221, net: 66154581360989 };
      const payload = single
        ? { items: [...items, ...Object.entries(giftIds).map(([kind, id]) => ({ id, quantity: 1, parent_id: items[0].id, properties: { _PyreFitGift: '1', _PyreFitGiftKind: kind } }))],
            ...(sectionIds.length ? { sections: sectionIds, sections_url: location.pathname } : {}) }
        : { items };
      const response = await fetch(`${root}cart/add.js`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload) });
      const data = await response.json(); if (!response.ok) throw new Error(data.description || this.t("Das Hinzufügen war nicht möglich. Bitte versuchen Sie es erneut."));
      added = true;
      let sections = single ? data.sections : await addPackGifts(data.items, packCount, root, sectionIds);
      let cart = await fetch(`${root}cart.js`).then(r => r.json());
      if (isPack) {
        const rate = packCount === 2 ? .9 : .83;
        // Confirm the price of the submitted garments, not the currently selected pack.
        const confirmed = candidate => {
          if (!Number.isFinite(candidate?.total_price)) return false;
          const lines = (candidate.items || []).filter(line =>
            line.properties?._PyreFitPack === packId && !line.properties?._PyreFitGift);
          if (lines.length !== picked.length) return false;
          return picked.every((variant, index) => {
            const line = lines.find(item => item.properties?._PyreFitGarment === `${packId}-${index}`);
            return line && Number(line.variant_id || line.id) === Number(variant.id)
              && line.quantity === 1 && Number.isFinite(line.final_line_price)
              && line.final_line_price <= Math.ceil(variant.price * rate);
          });
        };
        if (!confirmed(cart)) {
          // Re-read only on a failed check; normal additions need no extra request.
          const fresh = await fetch(`${root}cart.js`, { cache: 'no-store' });
          if (fresh.ok) cart = await fresh.json();
        }
        if (!confirmed(cart)) {
          finishProgress();
          this.dispatchEvent(new CartAddEvent(cart, this.id, { source: 'jacket-nineheat-main', productId: this.dataset.productId, itemCount: items.length, sections }));
          document.querySelector('cart-drawer-component')?.open();
          throw new Error(this.t("Die Jacken sind im Warenkorb, aber der Paketrabatt wurde nicht bestätigt. Bitte prüfen Sie den Preis vor dem Bezahlen."));
        }
      }
      finishProgress();
      if (buyNow) { redirecting = true; window.location.assign(`${root}checkout`); return; }
      this.dispatchEvent(new CartAddEvent(cart, this.id, { source: 'jacket-nineheat-main', productId: this.dataset.productId, itemCount: items.length, sections }));
      document.querySelector('cart-drawer-component')?.open();
    } catch (err) { error.textContent = err.message; error.hidden = false; if (added) error.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
    finally {
      this.adding = false; finishProgress(); button.disabled = this.picked().some(v => !v?.available);
      if (buyNow) {
        const reset = () => { buyNow.disabled = false; buyNow.removeAttribute('aria-busy'); buyNow.textContent = buyNowLabel; };
        // Keep the loading state while the checkout loads; restore it if the shopper comes back (bfcache).
        if (redirecting) window.addEventListener('pageshow', reset, { once: true }); else reset();
      }
    }
  }

}
if (!customElements.get('jacket-nineheat-main')) customElements.define('jacket-nineheat-main', JacketNineheatMain);
